export const FLAG_GETTING_FOODS = 'FLAG_GETTING_FOODS';
export const GET_FOODS = 'GET_FOODS';
export const CLEAR_FOODS = 'CLEAR_FOODS';
